import { render, staticRenderFns } from "./HeadPage.vue?vue&type=template&id=0012ff3f&scoped=true"
import script from "./HeadPage.vue?vue&type=script&lang=js"
export * from "./HeadPage.vue?vue&type=script&lang=js"
import style0 from "./HeadPage.vue?vue&type=style&index=0&id=0012ff3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0012ff3f",
  null
  
)

export default component.exports